export default "__VITE_ASSET__B_6faYPZ__"